export * from '@primeuix/themes/nora/dock';
export { default } from '@primeuix/themes/nora/dock';
